import styled from 'styled-components'

export const LoadingWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	width: 100%;
	max-width: 600px;
`

export const CheckoutWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto;
	max-width: 600px;
`
